<template>
  <div>
    <ProductServiceTopMenu :title="$t('product-service.view-feed')" />
    <Form v-bind:is-view="true"></Form>
  </div>
</template>

<script>
import ProductServiceTopMenu from "@/components/product_service/TopMenu";
import Form from "./Form";

export default {
  name: "ProductServicePapView",
  components: {
    Form,
    ProductServiceTopMenu
  }
};
</script>
